module.exports = __webpack_public_path__ + "img/mail_settings.d90c3894.svg";